import ButtonGroup, { ButtonGroupProps } from './ButtonGroup';

export type { ButtonGroupProps };
export default ButtonGroup;
